
  import { Vue, Component, Prop, Emit } from "vue-property-decorator";
  import { IEmailViewModel, IAdsModel, IUserModel } from "@/models";
  import { EmailService } from "@/services";
  import FormInput from "@/components/validate/FormInput.vue";
  import FormText from "@/components/validate/FormText.vue";
  import { ValidationObserver } from "vee-validate/dist/vee-validate.esm.js";
  import "@/helper/validate";
  import { getModule } from "vuex-module-decorators";
  import { Auth } from "@/store/modules/AuthModule";
  import store from "@/store";

  const AuthModule = getModule(Auth, store);

  @Component({
    name: "FormEmailToFriend",
    components: { FormInput, FormText, ValidationObserver }
  })
  export default class FormEmailToFriend extends Vue {
    $refs!: {
      form: InstanceType<typeof ValidationObserver>;
    };
    uniqueId: number = 0;
    firstName: string = "";
    lastName: string = "";
    @Prop() item!: IAdsModel;
    from: string = "";
    receiver: string = "";
    content: string = "";
    isLoading: boolean = false;
    @Emit("callback")
    onCallback(success: boolean) {}

    created() {
      if (AuthModule.isAuthenticated) {
        const {
          email,
          uniqueId,
          firstName,
          lastName
        } = AuthModule.currentUser as IUserModel;
        this.uniqueId = uniqueId;
        this.firstName = firstName;
        this.lastName = lastName;
        this.from = email;
      }
    }
    async onClick() {
      const { isValid, errors } = await this.$refs.form.validateWithInfo();
      if (!isValid) {
        const length = Object.keys(errors).length;
        for (var i = 0; i < length; i++) {
          const errorFieldName = Object.keys(errors)[i];
          if (errors[errorFieldName].length > 0) {
            this.$refs[errorFieldName].focus();
            break;
          }
        }

        return false;
      }

      this.isLoading = true;
      var model: IEmailViewModel = {
        adId: this.item.adId,
        from: this.from,
        fromName: `${this.firstName} ${this.lastName}`,
        replyToName: `${this.firstName} ${this.lastName}`,
        replyToEmail: this.from,
        uniqueId: this.uniqueId,
        to: this.receiver,
        toName: this.item.name,
        subject: `${this.item.title}`,
        body: this.content
      };

      var response = await EmailService.SendEmailToFriend(model);
      this.isLoading = false;
      this.reset();
      if (response.status === 200) {
        this.onCallback(true);
      } else {
        this.onCallback(false);
      }
    }

    reset() {
      this.from = "";
      this.content = "";
      this.receiver = "";
      this.isLoading = false;
      this.uniqueId = 0;
      this.firstName = "";
      this.lastName = "";
    }

    get isSaveButtonDisabled() {
      return this.isLoading;
    }
  }
